<template>
  <div class="all">
    <Head></Head>
    <div class="ArticleDetails">
      <div style="text-align: center;line-height: 50px;font-size: 18px;">
        全有动态
      </div>
      <div class="ArticleDetails-title" v-for="(item,key) in list" :key="key">
        <p>{{item.title}} </p>
        <span @click="$router.push({path:'/ArticleDetails',query:{id:item.id}})">{{item.add_time | filterDate('yyyy年MM月dd日 hh:mm')}}点击查看</span>
        <div class="clear"></div>
      </div>
    </div>
    <Pagetail></Pagetail>
  </div>
</template>

<script>
  import {getnews} from "../api/index";
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  export default {
    name: "Article",
    components:{
      Pagetail,Head
    },
    data(){
      return{
        list:[]
      }
    },
    mounted() {
      this.init()
    },
    methods:{
      init(){
        getnews().then(res=>{
          this.list = res.result
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .ArticleDetails{
    width: 1200px;
    margin: 0 auto;
  }
  .ArticleDetails-title{
    width: 900px;
    margin: 0 auto;
    line-height: 60px;
    border-bottom: 1px solid #ccc;
    p{
      float: left;
      padding-left: 20px;
    }
    span{
      float: right;
      padding-right: 20px;
      font-size: 14px;
      color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Article.vue